import * as React from 'react';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
export class InputSelect extends React.Component {
    constructor() {
        super();

        this.state = {
            readOnly: true,
            value: ""
        }
    }   
    render() {
        const selectId = this.props.id;
        const labelId = `${selectId}-label`;

        return (
            <div style={this.props.wraperStyle}>
                <Select
                    id={selectId}
                    name={this.props.name}
                    variant="standard"
                    labelId={labelId}
                    style={this.props.inputStyle}
                    value={this.props.value}
                    onChange={this.props.onChange}                    
                    readOnly={this.props.readOnly}                    
                >
                    {this.props.children}
                </Select>
                {this.props.inputLabelText ?
                    <InputLabel id={labelId} style={this.props.labelStyle}>{this.props.inputLabelText}</InputLabel>
                    : null
                }
            </div>	
        );
    }
}
